const ENV_API_BASE = process.env.REACT_APP_API_BASE
  || process.env.REACT_APP_API_BASE_URL
  || '';

const FALLBACK_API_BASE = 'https://igmportariaremota.com.br:3838';

let apiBase = ENV_API_BASE || FALLBACK_API_BASE;

if (typeof window !== 'undefined' && apiBase) {
  try {
    const parsed = new URL(apiBase);
    const isLocalBase = ['localhost', '127.0.0.1', '0.0.0.0'].includes(parsed.hostname);
    const currentHost = window.location.hostname;
    const isLocalHost = ['localhost', '127.0.0.1'].includes(currentHost);

    if (isLocalBase && currentHost && !isLocalHost) {
      parsed.hostname = currentHost;
      apiBase = parsed.toString().replace(/\/$/, '');
    }
  } catch (error) {
    // ignora URL invalida e mantém apiBase atual
  }
}

export const API_BASE = apiBase;

export const buildApiUrl = (path) => {
  if (!path) return API_BASE;
  return path.startsWith('/') ? `${API_BASE}${path}` : `${API_BASE}/${path}`;
};

export const resolveMediaUrl = (arquivo) => {
  if (!arquivo) return '';
  return `${API_BASE}/Media/${arquivo}`;
};
